import React from "react";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const localTheme = (outerTheme) =>
    createMuiTheme({
        ...outerTheme,
        overrides: {
            MuiOutlinedInput: {
                root: {
                    borderRadius: 10,
                    "& $notchedOutline": {
                        borderColor: "var(--drawerIcons)",
                    },
                    "&:hover $notchedOutline": {
                        borderColor: "var(--drawerIcons)",
                    },
                    '&.Mui-disabled $notchedOutline': {
                        borderColor: "var(--drawerIcons)",
                    },
                },
                input: {
                    color: "var(--mainText)",
                    "&::placeholder": {
                        color: "var(--mainText)",
                        opacity: 0.7,
                    },
                    '&.Mui-disabled': {
                        color: "var(--mainText)",
                        WebkitTextFillColor: "var(--mainText)",
                        opacity: 0.7,
                    },
                },
            },
            MuiInputLabel: {
                root: {
                    color: "#aaaaaa",
                },
            },
        },
    });

export default function ScopedTextField(props) {
    return (
        <ThemeProvider theme={localTheme}>
            <TextField {...props} variant="outlined" />
        </ThemeProvider>
    );
}